import isNil from 'lodash-es/isNil';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import styles from './SidebarFields.module.scss';

interface Props {
  validSubscribersCount: number;
  errorsCount: number;
  contextVariablesCount?: number;
}
const SidebarFields = ({
  validSubscribersCount = 0,
  errorsCount = 0,
  contextVariablesCount,
}: Props) => {
  const { t } = useTranslation();

  const filesData = [
    { label: t('broadcasts.recipients'), value: validSubscribersCount },
    { label: t('common.variables'), value: contextVariablesCount ?? 0 },
    { label: t('common.errors'), value: errorsCount },
  ];

  return (
    <div
      className={cn(styles.sidebarHeader, {
        [styles.hasContextVariables]: !isNil(contextVariablesCount),
      })}
    >
      {filesData.map((item) => {
        if (item.label === t('common.variables') && isNil(contextVariablesCount)) {
          return null;
        }
        return (
          <div className={styles.box} key={item.label}>
            <span className="text-sm leading-5 font-medium text-foreground-muted">
              {item.label}
            </span>
            <span className="text-xl leading-7 font-bold">
              {isNaN(item.value) ? 0 : item.value}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default SidebarFields;
